import { combineReducers } from 'redux';
import contacts from './contacts';
import views from './views';
import auth from './auth';
import news from './news';

export default combineReducers({

    news
})